import { Service } from '@roc/feature-app-core';

const url = {
  SUBMIT_RESOLUTION: '/api/v1/taskV2/resolution/submitResolution',
};

export class ResolutionService extends Service {

  submitResolution(taskId: number, comment: string, file?: File) {
    const formData = new FormData();
    formData.append('comment', comment);
    if (file) {
      formData.append('file', file);
    }
    return this.post(`${url.SUBMIT_RESOLUTION}?taskId=${taskId}`, formData);
  }

}
